import Vue from 'vue';
export default Vue.extend({
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
        iconName: {
            type: String,
            required: true
        },
        link: {
            required: true
        },
        linkOut: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({})
});
